import { CallFrameAppletCapability } from '@doxyme/extensions-bridge';
import { useAddCapability } from '@doxyme/extensions-bridge-react';
import { bridge } from '../../../features/extensions/instances';
import { useExtensionsMultiplayerCall } from '../useExtensionsMultiplayer';

/**
 * Hook thats just groups other hooks that add capabilities during the call, also allows to use noop hook only in one place instead of 3.
 */
export const useExtensionsCallCapabilities = (): void => {
  useExtensionsMultiplayerCall();
  useAddCapability(bridge, () => new CallFrameAppletCapability());
};
